import { apiErrorHandler } from '@/helpers/errorHandlers'

import API from '../client'

const fetchPatients = async (params) => {
  const route = `api/patients`
  return API.get(route, { params })
    .then((response) => Promise.resolve(response.data))
    .catch((error) => Promise.reject(apiErrorHandler(error.response.data)))
}

const addNewPatient = async (data) => {
  const route = `api/patients`
  return API.post(route, data)
    .then((response) => Promise.resolve(response.data))
    .catch((error) => Promise.reject(apiErrorHandler(error.response.data)))
}

const deletePatient = async (id) => {
  const route = `api/patients/${id}`
  return API.delete(route)
    .then((response) => Promise.resolve(response.data))
    .catch((error) => Promise.reject(apiErrorHandler(error.response.data)))
}

const putPatient = async (data) => {
  const route = `api/patients`
  return API.put(route, data)
    .then((response) => Promise.resolve(response.data))
    .catch((error) => Promise.reject(apiErrorHandler(error.response.data)))
}

const fetchOnePatient = async (id) => {
  const route = `api/patients/${id}`
  return API.get(route)
    .then((response) => Promise.resolve(response.data))
    .catch((error) => Promise.reject(apiErrorHandler(error.response.data)))
}

export { addNewPatient, deletePatient, fetchOnePatient, fetchPatients, putPatient }
